import React, { useState } from "react"

import * as ModalModule from "../../components/shared/Modal"
import TypographyJs from "../../components/shared/Typography"

type AnyProps = Record<string, unknown> & { children?: React.ReactNode }
const AnimatedModal = ModalModule.AnimatedModal as unknown as React.FC<AnyProps>
const Typography = TypographyJs as unknown as React.FC<AnyProps>

type IntakeFormArchiveConfirmModalProps = {
  visible: boolean
  formName?: string
  onClose: () => void
  onConfirm: () => Promise<void>
}

export default function IntakeFormArchiveConfirmModal({
  visible,
  formName,
  onClose,
  onConfirm
}: IntakeFormArchiveConfirmModalProps) {
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await onConfirm()
    } finally {
      setLoading(false)
    }
  }

  return (
    <AnimatedModal
      visible={visible}
      hideModal={onClose}
      header="Archive intake form"
      showFooter
      hideSaveButton
      hideCancelButton
      footerButtons={[
        {
          label: "Go back",
          type: "tertiary",
          onClick: onClose,
          disabled: loading
        },
        {
          label: loading ? "Archiving…" : "Archive",
          type: "warning",
          onClick: handleConfirm,
          disabled: loading
        }
      ]}>
      <Typography variant="body" as="p">
        Are you sure you want to archive
        {formName ? (
          <>
            {" "}
            <span className="font-semibold">{formName}</span>
          </>
        ) : null}
        ? It will no longer be available to send to clients.
      </Typography>
    </AnimatedModal>
  )
}
